import script from "./NewsRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsRoute.vue?vue&type=script&setup=true&lang=js"

import "./NewsRoute.vue?vue&type=style&index=0&id=19d51382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d51382"]])

export default __exports__